import React from "react";
import Select from "react-select";
import "../styles/AddUserNew.css";
const CustomRoleSelect = ({ value, onChange, ...props }) => {
  const options = [
    { value: "ROLE_USER", label: "User" },
    { value: "ROLE_ADMIN", label: "Admin" },
  ];

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      border: `2px solid ${state.isFocused ? "#4f46e5" : "#e2e8f0"}`,
      borderRadius: "16px",
      fontSize: "1.05rem",
      fontWeight: "500",
      color: "#1e293b",
      background: state.isFocused ? "#fefefe" : "#ffffff",
      transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
      outline: "none",
      boxSizing: "border-box",
      fontFamily: '"Host Grotesk", sans-serif',
      minHeight: "52px",
      cursor: "pointer",
      boxShadow: state.isFocused
        ? "0 0 0 4px rgba(79, 70, 229, 0.08), 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.08)"
        : state.isHovered
        ? "0 2px 4px -1px rgba(0, 0, 0, 0.03)"
        : "none",
      transform: state.isFocused
        ? "translateY(-2px)"
        : state.isHovered
        ? "translateY(-1px)"
        : "translateY(0)",
      "&:hover": {
        borderColor: state.isFocused ? "#4f46e5" : "#cbd5e1",
      },
      "&:focus": {
        outline: "none",
        border: `2px solid #4f46e5`,
      },
      "&:focus-within": {
        outline: "none",
      },
    }),

    valueContainer: (provided) => ({
      ...provided,
      padding: "0 1.25rem",
      fontFamily: '"Host Grotesk", sans-serif',
    }),

    input: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
      fontFamily: '"Host Grotesk", sans-serif',
      fontSize: "1.05rem",
      fontWeight: "500",
      color: "#1e293b",
      outline: "none",
      "&:focus": {
        outline: "none",
        boxShadow: "none",
      },
    }),

    placeholder: (provided) => ({
      ...provided,
      color: "#94a3b8",
      fontWeight: "400",
      fontFamily: '"Host Grotesk", sans-serif',
      fontSize: "1.05rem",
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#1e293b",
      fontFamily: '"Host Grotesk", sans-serif',
      fontSize: "1.05rem",
      fontWeight: "500",
    }),

    menu: (provided) => ({
      ...provided,
      borderRadius: "16px",
      border: "2px solid #e2e8f0",
      boxShadow:
        "0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.08)",
      overflow: "hidden",
      fontFamily: '"Host Grotesk", sans-serif',
      marginTop: "4px",
      zIndex: 9999,
      position: "absolute",
    }),

    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),

    menuList: (provided) => ({
      ...provided,
      padding: "0",
      borderRadius: "16px",
      fontFamily: '"Host Grotesk", sans-serif',
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#4f46e5"
        : state.isFocused
        ? "#f8fafc"
        : "#ffffff",
      color: state.isSelected ? "#ffffff" : "#1e293b",
      padding: "1rem 1.25rem",
      fontSize: "1.05rem",
      fontWeight: "500",
      fontFamily: '"Host Grotesk", sans-serif',
      cursor: "pointer",
      transition: "all 0.15s ease",
      borderBottom: "1px solid #f1f5f9",
      outline: "none",
      "&:last-child": {
        borderBottom: "none",
      },
      "&:hover": {
        backgroundColor: state.isSelected ? "#4f46e5" : "#f8fafc",
      },
      "&:focus": {
        outline: "none",
      },
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: state.isFocused ? "#4f46e5" : "#475569",
      padding: "0 1.25rem",
      transition: "all 0.25s ease",
      transform: state.selectProps.menuIsOpen
        ? "rotate(180deg)"
        : "rotate(0deg)",
      "&:hover": {
        color: "#4f46e5",
      },
    }),

    clearIndicator: (provided) => ({
      ...provided,
      color: "#64748b",
      padding: "0 0.5rem",
      "&:hover": {
        color: "#dc2626",
      },
    }),
  };

  const handleChange = (selectedOption) => {
    onChange({
      target: {
        name: "role",
        value: selectedOption ? selectedOption.value : "",
      },
    });
  };

  const selectedValue =
    options.find((option) => option.value === value) || null;

  return (
    <div className="adduser-input-group">
      <label htmlFor="role" className="adduser-field-label">
        Role
      </label>
      <Select
        id="role"
        name="role"
        options={options}
        value={selectedValue}
        onChange={handleChange}
        placeholder="Select a role"
        styles={customSelectStyles}
        isSearchable={false}
        isClearable={false}
        className="adduser-custom-select"
        classNamePrefix="adduser-select"
        menuPortalTarget={document.body}
        menuPosition="absolute"
        aria-live="off"
        screenReaderStatus={() => ""}
        {...props}
      />
    </div>
  );
};

export default CustomRoleSelect;
